import { locationApi } from "../api";

const LocationService = {
  // 🔹 Obtener todos los departamentos
  fetchDepartments: async () => {
    const response = await locationApi.fetchCustom('/departments');
    return response.data;
  },

  // 🔹 Obtener municipios por código del departamento
  fetchMunicipalitiesByDepartment: async (departmentCode: string) => {
    const response = await locationApi.fetchCustom(`/departments/${departmentCode}/municipalities`);
    return response.data;
  },
};

export default LocationService;
